import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import Responsive from "../../modules/Responsive";
import { DynamicPaginationDesktop } from "./components/DynamicPaginationDesktop/DynamicPaginationDesktop";
import { DynamicPaginationMobile } from "./components/DynamicPaginationMobile/DynamicPaginationMobile";
import { DESKTOP_MIN_WIDTH, MOBILE_MAX_WIDTH } from "./constants";
export var DynamicPagination = function DynamicPagination(_ref) {
  var previousButtonLabel = _ref.previousButtonLabel,
      nextButtonLabel = _ref.nextButtonLabel,
      paginationLabel = _ref.paginationLabel,
      totalPages = _ref.totalPages,
      totalItems = _ref.totalItems,
      pageSize = _ref.pageSize,
      startFromPage = _ref.startFromPage,
      viewingLabel = _ref.viewingLabel,
      rowsPerPageLabelContent = _ref.rowsPerPageLabelContent,
      rowsPerPageLabel = _ref.rowsPerPageLabel,
      rowsPerPageValues = _ref.rowsPerPageValues,
      goToPageError = _ref.goToPageError,
      onPageChange = _ref.onPageChange,
      onPageSizeChange = _ref.onPageSizeChange,
      _ref$isMultipleRows = _ref.isMultipleRows,
      isMultipleRows = _ref$isMultipleRows === void 0 ? true : _ref$isMultipleRows;
  var totalPagesDisplayed = Math.max(totalPages, 1);

  var _useState = useState(startFromPage || 1),
      _useState2 = _slicedToArray(_useState, 2),
      currentPage = _useState2[0],
      setCurrentPage = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      goToPageNum = _useState4[0],
      setGoToPageNum = _useState4[1];

  var rowsPerPageOptions = (rowsPerPageValues === null || rowsPerPageValues === void 0 ? void 0 : rowsPerPageValues.map(function (item) {
    return {
      label: "".concat(item),
      value: item
    };
  })) || [];
  useEffect(function () {
    if (startFromPage) {
      setCurrentPage(startFromPage);
    }
  }, [startFromPage]);
  var canPreviousPage = currentPage !== 1;
  var canNextPage = currentPage !== totalPagesDisplayed;

  var handlePageChange = function handlePageChange(pageNumber) {
    if (pageNumber > 0) {
      setCurrentPage(pageNumber);
      onPageChange(pageNumber);
      setGoToPageNum(0);
    }
  };

  var handleGoToPage = function handleGoToPage(event) {
    setGoToPageNum(Number(event.target.value));
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (["e", "E", "+", "-"].includes(event.key)) {
      event.preventDefault();
    }

    if (event.key === "Enter" && Number(event.target.value) <= totalPages) {
      setGoToPageNum(Number(event.target.value));
      handlePageChange(Number(event.target.value));
    }
  };

  var isInvalidPageNum = goToPageNum > totalPagesDisplayed;

  var handlePageSizeChange = function handlePageSizeChange(size) {
    handlePageChange(1);
    onPageSizeChange(size);
  };

  if (totalPages === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  var viewFrom = (currentPage - 1) * pageSize + 1;
  var viewTo = currentPage === totalPages ? totalItems : currentPage * pageSize;
  var viewingLabelContent = viewingLabel || "";
  var dynamicPaginationProps = {
    currentPage: currentPage,
    viewingLabelContent: viewingLabelContent,
    rowsPerPageLabelContent: rowsPerPageLabelContent !== null && rowsPerPageLabelContent !== void 0 ? rowsPerPageLabelContent : "",
    isInvalidPageNum: isInvalidPageNum,
    canPreviousPage: canPreviousPage,
    canNextPage: canNextPage,
    goToPageNum: goToPageNum,
    viewFrom: viewFrom,
    viewTo: viewTo,
    rowsPerPageOptions: rowsPerPageOptions,
    previousButtonLabel: previousButtonLabel,
    nextButtonLabel: nextButtonLabel,
    paginationLabel: paginationLabel,
    totalPages: totalPages,
    totalItems: totalItems,
    pageSize: pageSize,
    rowsPerPageLabel: rowsPerPageLabel,
    goToPageError: goToPageError,
    handlePageSizeChange: handlePageSizeChange,
    handleGoToPage: handleGoToPage,
    handleKeyDown: handleKeyDown,
    handlePageChange: handlePageChange,
    isMultipleRows: isMultipleRows
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Responsive, {
    minWidth: DESKTOP_MIN_WIDTH
  }, /*#__PURE__*/React.createElement(DynamicPaginationDesktop, dynamicPaginationProps)), /*#__PURE__*/React.createElement(Responsive, {
    minWidth: 0,
    maxWidth: MOBILE_MAX_WIDTH
  }, /*#__PURE__*/React.createElement(DynamicPaginationMobile, dynamicPaginationProps)));
};
DynamicPagination.displayName = "DynamicPaginationSaf";